import type { FC } from 'react';
import type { MessageDescriptor } from 'react-intl-next';

import { NTH_USER_ONBOARDING_ACTIONS_DATA } from './HTVNthUserCards.tsx';

const DUPLICATED_ONBOARDING_ACTION_IDS = [...NTH_USER_ONBOARDING_ACTIONS_DATA].map(
	(action) => action.id,
);
export const ONBOARDING_ACTION_IDS = [...new Set(DUPLICATED_ONBOARDING_ACTION_IDS)];
export const ONBOARDING_ACTION_STATES = ['pending', 'dismissed', 'completed'] as const;

export type OnboardingActionId = (typeof ONBOARDING_ACTION_IDS)[number];
export type OnboardingActionState = (typeof ONBOARDING_ACTION_STATES)[number];
export type OnboardingActionStates = Partial<Record<OnboardingActionId, OnboardingActionState>>;
export type OnboardingAction = {
	id: OnboardingActionId;
	image: { light: string; dark: string };
	title: React.ReactNode;
	description: MessageDescriptor;
	cta: FC<{ onClick: () => void }>;
	state: OnboardingActionState;
	keepCtaOnCompleted?: boolean;
	fadeCardOnComplete?: boolean;
};
